import { format$Price, formatPrice } from 'utils/helpers/functions/formatPrice';
import { withLocalCurrency } from 'utils/helpers/currency/currencyHelpers';

/** Сума без копійок і знака валюти — знак стоїть біля назви блока. */
export const formatPlainAmount = (amount: number, showPlus = false) => {
    const formatted = Math.abs(amount).toLocaleString('en-US', { maximumFractionDigits: 0 });
    if (amount < 0) return `-${formatted}`;
    return `${showPlus ? '+' : ''}${formatted}`;
};

export const formatItemAmount = (amount: number, isUahMode: boolean, showPlus = false) => {
    if (isUahMode) {
        return amount >= 0
            ? `${showPlus ? '+' : ''}${withLocalCurrency(formatPrice(amount))}`
            : withLocalCurrency(formatPrice(-amount), true);
    }
    return format$Price(amount, showPlus);
};

export const rateTitle = (isUahMode: boolean, rate?: number) => {
    if (isUahMode || rate == null) return undefined;
    return withLocalCurrency(formatPrice(rate));
};
